import { render, staticRenderFns } from "./exchangeShop.vue?vue&type=template&id=c7c83296&scoped=true"
import script from "./exchangeShop.vue?vue&type=script&lang=ts"
export * from "./exchangeShop.vue?vue&type=script&lang=ts"
import style0 from "./exchangeShop.vue?vue&type=style&index=0&id=c7c83296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c83296",
  null
  
)

export default component.exports